export default {
  WOKAP_IA: {
    WIZARD: {
      TITLE: 'wokapIA',
      NAVBAR_TITLE: 'Encuentra tu candidat@',
      SUBTITLE: 'wokapIA es la <b>red de wokap</b> donde puedes encontrar tu candidat@ ideal e invitarl@ a inscribirse a tu oferta. Sigue los siguientes pasos.',
      ARIA_LABEL: 'Pasos del wizard wokapIA',
      STEPS: {
        OCCUPATION: 'Perfil',
        FILTERS: 'Filtrar',
        SAVE: 'Confirmar',
        OFFERS: 'Crear oferta',
      },
      STEP_DESCRIPTIONS: {
        OCCUPATION: {
          TITLE: 'Ocupación / Profesión',
          DESCRIPTION: 'Selecciona la Ocupación / Profesión de l@s candidat@s que mejor se adapten a tu vacante.',
        },
        FILTERS: {
          TITLE: 'Filtrar',
          DESCRIPTION: 'Aplica filtros para definir las características de l@s candidat@s que buscas.',
        },
        SAVE: {
          TITLE: 'Confirmar',
          DESCRIPTION: 'Asigna un título a la carpeta y confirma l@s candidat@s que deseas invitar.',
        },
        OFFERS: {
          TITLE: 'Crear la oferta',
          DESCRIPTION: 'Crea la oferta para que enviemos una invitación a l@s candidat@s que seleccionaste. Cuando l@s candidat@s se inscriban, podrás gestionarl@s dentro de la oferta.\nAdemás, cualquier usuari@ de wokap interesad@ en tu vacante también podrá postularse. Utiliza los filtros para distinguir fácilmente entre l@s candidat@s que invitaste y quienes llegaron por iniciativa propia.\nUna vez creada y publicada, la oferta se mostrará en tu “Panel de ofertas”.',
        },
      },
    },
    OCCUPATION: {
      TITLE: 'Selecciona los perfiles que estás buscando.',
      LABEL: 'Ocupación / Profesión',
      DESCRIPTION: 'Selecciona la Ocupación / Profesión de l@s candidat@s que mejor se adapten a tu vacante.',
      NETWORK_BADGE: 'Red de wokap',
      SELECT_OCCUPATION_ERROR: 'Selecciona al menos una ocupación para continuar.',
      SEARCH_PLACEHOLDER: 'Buscar Ocupación / Profesión',
    },
    FILTERS: {
      OCCUPATIONS_SELECTED_LABEL: 'Ocupaciones / Profesiones seleccionadas:',
      OCCUPATION_LABEL: 'Ocupación / Profesión',
      OCCUPATIONS_COUNT_LABEL: 'ocupaciones',
      FORMATION_LABEL: 'Formación / Estudios',
      COUNTRY_LABEL: 'País',
      CITY_LABEL: 'Ciudad',
      CITY_LOCKED: 'Selecciona primero un país.',
      LANGUAGE_LABEL: 'Idiomas',
      LANGUAGE_LEVEL_LABEL: 'Nivel mínimo',
      LEVEL_BASIC: 'Básico',
      LEVEL_INTERMEDIATE: 'Intermedio',
      LEVEL_ADVANCED: 'Avanzado',
      LEVEL_NATIVE: 'Nativo',
      HARD_SKILLS_LABEL: 'Aptitudes Técnicas (hard skills)',
      SOFT_SKILLS_LABEL: 'Aptitudes Interpersonales (soft skills)',
      OTHER_LABEL: 'Otras competencias',
      CLEAR_FILTERS: 'Limpiar filtros',
      SEARCH_IN_FILTER: 'Buscar...',
      SEE_MORE: 'Ver más',
      SEE_LESS: 'Ver menos',
      FILTERS_TITLE: 'Filtros',
      CANDIDATES_TITLE: 'Candidat@s',
      RESULTS_COUNT: 'candidat@s',
      NO_RESULTS_TITLE: 'Sin candidat@s con esos filtros',
      NO_RESULTS_SUB: 'Prueba ajustando algún filtro.',
      SELECTION_LABEL: 'candidat@s seleccionad@s',
      SELECT_CANDIDATE_ERROR: 'Selecciona al menos un candidat@ para continuar.',
      SAVE_TO_OFFER: 'Guardar en oferta →',
      BACK_BTN: 'Volver',
      NEXT_BTN: 'Continuar',
      PREV_BTN: 'Volver',
    },
    SAVE_OFFER: {
      TITLE: 'Guardar en oferta',
      SUBTITLE: 'Archiva l@s candidat@s seleccionad@s.\nDespués crearás la oferta para poder invitarl@s.',
      OFFER_NAME_LABEL: 'Nombre de la carpeta',
      OFFER_NAME_PLACEHOLDER: 'Ej: Arquitecto/a proyecto residencial',
      CANDIDATES_LABEL: 'Candidat@s seleccionad@s',
      CANDIDATES_TOOLTIP: 'Una vez que crees la oferta, est@s candidat@s recibirán la invitación para inscribirse a tu vacante',
      CANCEL: 'Cancelar',
      SAVE: 'Guardar oferta',
      NO_CANDIDATES_TOOLTIP: 'No puedes avanzar sin candidat@s seleccionad@s',
      ERROR_TITLE_REQUIRED: 'Escribe el nombre de la carpeta.',
      ERROR_CANDIDATES_REQUIRED: 'Regresa a la pantalla anterior para añadir candidat@s a tu oferta.',
    },
    OFFER_DECISION: {
      TITLE: '¿Quieres crear la oferta ahora?',
      SUBTITLE: 'Al crearla y publicarla, enviaremos una invitación a l@s candidat@s seleccionad@s.',
      OFFER_NAME_LABEL: 'Nombre de la carpeta:',
      CANDIDATES_TO_INVITE: 'candidat@s por invitar',
      CREATE_NOW_TITLE: 'Crear oferta ahora',
      CREATE_NOW_DESC: 'Completa la oferta, publícala e invita automáticamente a tu selección.',
      SAVE_LATER_TITLE: 'Guardar para después',
      SAVE_LATER_DESC: 'Aparecerá en "Ofertas por crear" hasta que decidas continuar.',
      BACK_BTN: 'Volver',
    },
    OFFER_PANEL: {
      SECTION_TITLE: 'Ofertas por crear',
      EMPTY: 'No hay ofertas pendientes de crear.',
      TABLE: {
        TITLE: 'Título / Puesto',
        CANDIDATES: 'Candidat@s por invitar',
        CANDIDATES_LABEL: 'candidat@s',
        DATE: 'Fecha',
        DATE_TOOLTIP: 'Fecha en la que se creó la oferta',
        CANDIDATES_TOOLTIP: 'Una vez que crees la oferta, est@s candidat@s recibirán la invitación para inscribirse a tu vacante',
        STATUS: 'Estado',
        ACTIONS: 'Acciones',
      },
      BADGE: {
        PENDING: 'Oferta pendiente de crearse',
        LINKED: 'Vinculada',
      },
      ACTION: {
        VIEW: 'Crear oferta',
        CREATE_OFFER: 'Crear oferta',
        DELETE: 'Eliminar',
        DELETE_CONFIRM_HEADER: 'Eliminar oferta en creación',
        DELETE_CONFIRM_MSG: '¿Estás segur@ que deseas eliminar esta oferta en creación?',
        DELETE_CONFIRM_ACCEPT: 'Eliminar',
        DELETE_CONFIRM_REJECT: 'Cancelar',
      },
      FINISH_BTN: 'Finalizar',
    },
    INVITE: {
      NO_OFFER: 'Sin oferta creada',
      NOTICE_TITLE: 'Antes de invitar, crea la oferta',
      NOTICE_SUB: 'Tus candidat@s necesitan ver de qué se trata la posición antes de decidir si aplican. Crea la oferta primero y luego podrás enviarles la invitación.',
      CREATE_OFFER_BTN: 'Crear oferta ahora',
      CANDIDATES_LABEL: 'Candidat@s archivad@s',
      CANDIDATE_STATUS: 'Pendiente de invitación',
      INVITE_ACTION: 'Invitar',
      BACK_BTN: 'Volver',
      NAV_NOTE: 'Crea la oferta para poder invitar.',
    },
    LEAVE_MODAL: {
      TITLE: 'Cambios sin guardar',
      MESSAGE: 'Tienes cambios sin guardar, ¿estás segur@ que quieres salir?',
      STAY: 'Quedarse',
      LEAVE: 'Salir sin guardar',
    },
  },
};
